import { defineStore } from "pinia";
import { useDistanceOriginStore } from "./distanceOrigin";

// Сессия экрана поиска: живёт дольше SearchPanel (панель размонтируется, пока
// открыта карточка объекта), чтобы «Назад» вернул тот же текст и прокрутку.
// Любой выход из поиска (крестик карточки объекта, уход со страницы карты,
// «Все маршруты») обязан вызвать cancel() - иначе остаются текст и снимок центра.
export const useSearchSessionStore = defineStore("searchSession", {
  state: () => ({
    open: false,
    query: "",
    scrollTop: 0,
    // "search" - объект открыт из поиска: «Назад» в карточке ведёт обратно в поиск.
    returnTo: null as "search" | null,
  }),
  actions: {
    // Новая сессия - свежий снимок центра (даже если прошлую закрыли мимо
    // cancel()); при ожидающем возврате из карточки - прежний снимок.
    openSearch() {
      const origin = useDistanceOriginStore();
      if (this.returnTo !== "search") origin.unfreeze();
      origin.freezeCenter();
      this.returnTo = null;
      this.open = true;
    },
    // «Отмена» / крестик карточки: в покой, без следа сессии.
    cancel() {
      this.open = false;
      this.query = "";
      this.scrollTop = 0;
      this.returnTo = null;
      useDistanceOriginStore().unfreeze();
    },
    rememberScroll(n: number) {
      this.scrollTop = n;
    },
    // Поиск сворачивается до карточки; текст, прокрутка и снимок центра остаются.
    markOpenedFromSearch() {
      this.returnTo = "search";
      this.open = false;
    },
    // «Назад» в карточке: был возврат в поиск - поиск снова открыт (с тем же
    // текстом, прокруткой и снимком центра) и вернётся true; иначе false.
    consumeReturn(): boolean {
      const pending = this.returnTo === "search";
      this.returnTo = null;
      if (pending) this.open = true;
      return pending;
    },
  },
});
